module.exports = "/images/trial-hub-icon.svg?6b6aa4c7c79d98a98b0572e961517730";